/**
 * MBF Dashboard Sample Data
 * 
 * This file contains sample data to display when the backend returns no data,
 * empty data, or zero values. The sample data demonstrates how charts and
 * visualizations will look with real data in MBF (Organization-wide) dashboard.
 */

// ==================== MBF USER STATISTICS SAMPLE DATA ====================

export const mbfUserStatisticsSampleData = {
    // Gender Stats
    genderStats: {
        male: 2450,
        female: 1850,
        male_percentage: 57,
        female_percentage: 43,
    },

    // Student vs Admin
    studentVsAdmin: {
        student_count: 3800,
        admin_count: 500,
    },

    // User Growth Trend - Monthly (last 12 months)
    userGrowthTrend: [
        { month: 'Jan', year: 2025, users: 2500 },
        { month: 'Feb', year: 2025, users: 2750 },
        { month: 'Mar', year: 2025, users: 3100 },
        { month: 'Apr', year: 2025, users: 3400 },
        { month: 'May', year: 2025, users: 3700 },
        { month: 'Jun', year: 2025, users: 3950 },
        { month: 'Jul', year: 2025, users: 4100 },
        { month: 'Aug', year: 2025, users: 4300 },
        { month: 'Sep', year: 2025, users: 4550 },
        { month: 'Oct', year: 2025, users: 4800 },
        { month: 'Nov', year: 2025, users: 5050 },
        { month: 'Dec', year: 2025, users: 5300 },
    ],

    // TL User Distribution
    tlUserDistribution: [
        { tl_id: 1, tl_name: 'IIT Mumbai TL', user_count: 1250, percentage: 29.1 },
        { tl_id: 2, tl_name: 'IIT Chennai TL', user_count: 980, percentage: 22.8 },
        { tl_id: 3, tl_name: 'NIT Surathkal TL', user_count: 750, percentage: 17.4 },
        { tl_id: 4, tl_name: 'BITS Pilani TL', user_count: 620, percentage: 14.4 },
        { tl_id: null, tl_name: 'Other', user_count: 700, percentage: 16.3 },
    ],

    // Department Distribution
    departmentDistribution: [
        { department: 'CSE', count: 1250 },
        { department: 'ME', count: 980 },
        { department: 'EE', count: 750 },
        { department: 'ECE', count: 620 },
        { department: 'CE', count: 450 },
        { department: 'Others', count: 250 },
    ],

    // Zone Statistics
    zoneStatistics: [
        { zone: 'West', count: 1450 },
        { zone: 'North', count: 1280 },
        { zone: 'South', count: 1150 },
        { zone: 'Central', count: 850 },
        { zone: 'East', count: 570 },
    ],
};

// ==================== MBF ENGAGEMENT SAMPLE DATA ====================

export const mbfEngagementSampleData = {
    // Cumulative Footfall (Weekly trend - MIS Logins vs TL Footfall)
    cumulativeFootfall: [
        { week: 'Week 01', mis_logins: 450, tl_footfall: 1250 },
        { week: 'Week 02', mis_logins: 520, tl_footfall: 1380 },
        { week: 'Week 03', mis_logins: 480, tl_footfall: 1420 },
        { week: 'Week 04', mis_logins: 610, tl_footfall: 1580 },
    ],

    // Individual TL Footfall (Daily breakdown)
    individualTLFootfall: [
        { day: 'Mon', footfall: 285 },
        { day: 'Tue', footfall: 320 },
        { day: 'Wed', footfall: 275 },
        { day: 'Thu', footfall: 345 },
        { day: 'Fri', footfall: 310 },
        { day: 'Sat', footfall: 180 },
        { day: 'Sun', footfall: 95 },
    ],

    // Peak Hours Analysis
    peakHoursAnalysis: [
        { time: '08:00', engagement_percentage: 25, reservation_count: 45 },
        { time: '09:00', engagement_percentage: 55, reservation_count: 98 },
        { time: '10:00', engagement_percentage: 85, reservation_count: 152 },
        { time: '11:00', engagement_percentage: 95, reservation_count: 170 },
        { time: '12:00', engagement_percentage: 65, reservation_count: 116 },
        { time: '13:00', engagement_percentage: 80, reservation_count: 143 },
        { time: '14:00', engagement_percentage: 100, reservation_count: 178 },
        { time: '15:00', engagement_percentage: 70, reservation_count: 125 },
    ],

    // Active Users Status
    activeUsersStatus: {
        active_users: 3850,
        inactive_users: 1450,
        active_percentage: 72.6,
        inactive_percentage: 27.4,
    },

    // Department-wise Engagement
    departmentEngagement: [
        { department: 'CSE', engagement_count: 2450 },
        { department: 'ME', engagement_count: 1850 },
        { department: 'EE', engagement_count: 1420 },
        { department: 'ECE', engagement_count: 1180 },
        { department: 'CE', engagement_count: 850 },
        { department: 'Others', engagement_count: 550 },
    ],

    // Year-wise Engagement
    yearEngagement: [
        { year: 'First Year', total_visits: 1850, active_users: 620 },
        { year: 'Second Year', total_visits: 2450, active_users: 850 },
        { year: 'Third Year', total_visits: 2850, active_users: 1050 },
        { year: 'Fourth Year', total_visits: 2150, active_users: 780 },
        { year: 'Fifth Year', total_visits: 1250, active_users: 450 },
    ],
};

// ==================== MBF PROJECTS SAMPLE DATA ====================

export const mbfProjectsSampleData = {
    // Cumulative Projects (Monthly trend - Total vs Completed)
    cumulativeProjects: [
        { month: 'Jan', total_projects: 185, completed_projects: 120 },
        { month: 'Feb', total_projects: 210, completed_projects: 145 },
        { month: 'Mar', total_projects: 245, completed_projects: 175 },
        { month: 'Apr', total_projects: 280, completed_projects: 210 },
        { month: 'May', total_projects: 320, completed_projects: 250 },
        { month: 'Jun', total_projects: 355, completed_projects: 285 },
        { month: 'Jul', total_projects: 385, completed_projects: 315 },
        { month: 'Aug', total_projects: 420, completed_projects: 350 },
        { month: 'Sep', total_projects: 460, completed_projects: 390 },
        { month: 'Oct', total_projects: 505, completed_projects: 435 },
        { month: 'Nov', total_projects: 545, completed_projects: 475 },
        { month: 'Dec', total_projects: 590, completed_projects: 520 },
    ],

    // Types of Projects
    typesOfProjects: [
        { type: 'Course Projects', count: 185, percentage: 31.4 },
        { type: 'Competitions', count: 125, percentage: 21.2 },
        { type: 'Professor Projects', count: 110, percentage: 18.6 },
        { type: 'Self Projects', count: 98, percentage: 16.6 },
        { type: 'Internships', count: 72, percentage: 12.2 },
    ],

    // Year-wise Distribution
    yearDistribution: [
        { year: 'First Year', students_involved: 450, projects: 85 },
        { year: 'Second Year', students_involved: 720, projects: 145 },
        { year: 'Third Year', students_involved: 850, projects: 185 },
        { year: 'Fourth Year', students_involved: 580, projects: 110 },
        { year: 'Fifth Year', students_involved: 280, projects: 45 },
    ],

    // Department-wise Projects
    departmentProjects: [
        { department: 'CSE', projects: 165, avg_duration_weeks: 4.5 },
        { department: 'ME', projects: 125, avg_duration_weeks: 6.2 },
        { department: 'EE', projects: 95, avg_duration_weeks: 5.1 },
        { department: 'ECE', projects: 78, avg_duration_weeks: 4.8 },
        { department: 'CE', projects: 52, avg_duration_weeks: 5.5 },
        { department: 'Others', projects: 35, avg_duration_weeks: 3.8 },
    ],

    // Trainings vs Quizzes (Monthly trend)
    trainingsVsQuizzes: [
        { month: 'Jan', trainings_completed: 45, quizzes_solved: 320 },
        { month: 'Feb', trainings_completed: 52, quizzes_solved: 385 },
        { month: 'Mar', trainings_completed: 48, quizzes_solved: 410 },
        { month: 'Apr', trainings_completed: 55, quizzes_solved: 450 },
        { month: 'May', trainings_completed: 62, quizzes_solved: 520 },
        { month: 'Jun', trainings_completed: 58, quizzes_solved: 480 },
        { month: 'Jul', trainings_completed: 42, quizzes_solved: 350 },
        { month: 'Aug', trainings_completed: 50, quizzes_solved: 420 },
        { month: 'Sep', trainings_completed: 65, quizzes_solved: 550 },
        { month: 'Oct', trainings_completed: 70, quizzes_solved: 620 },
        { month: 'Nov', trainings_completed: 68, quizzes_solved: 580 },
        { month: 'Dec', trainings_completed: 55, quizzes_solved: 450 },
    ],
};

// ==================== MBF MACHINE USAGE SAMPLE DATA ====================

export const mbfMachineUsageSampleData = {
    // Most Used Machines (Weekly, Monthly, Yearly)
    mostUsedMachines: [
        { machine_name: '3D Printer', weekly: 85, monthly: 320, yearly: 3850 },
        { machine_name: 'CNC Machine', weekly: 72, monthly: 285, yearly: 3420 },
        { machine_name: 'Laser Cutter', weekly: 58, monthly: 225, yearly: 2680 },
        { machine_name: 'Oscilloscope', weekly: 45, monthly: 175, yearly: 2100 },
        { machine_name: 'Soldering Station', weekly: 38, monthly: 150, yearly: 1800 },
        { machine_name: 'Multimeter', weekly: 28, monthly: 110, yearly: 1320 },
    ],

    // Machine Status Overview
    machineStatusOverview: {
        operational: 285,
        operational_percentage: 79.2,
        under_maintenance: 55,
        under_maintenance_percentage: 15.3,
        out_of_order: 20,
        out_of_order_percentage: 5.5,
    },

    // Most Issued Items (Weekly, Monthly, Yearly)
    mostIssuedItems: [
        { item_name: 'Arduino Uno', weekly: 125, monthly: 480, yearly: 5800 },
        { item_name: 'Breadboard', weekly: 98, monthly: 385, yearly: 4620 },
        { item_name: 'Jumper Wires', weekly: 250, monthly: 980, yearly: 11800 },
        { item_name: 'Resistors', weekly: 185, monthly: 720, yearly: 8650 },
        { item_name: 'LEDs', weekly: 145, monthly: 560, yearly: 6720 },
        { item_name: 'Sensors', weekly: 65, monthly: 250, yearly: 3000 },
    ],

    // Cost vs Usage
    costVsUsage: [
        { machine_name: '3D Printer A', machine_cost: 250000, usage_hours: 1850 },
        { machine_name: '3D Printer B', machine_cost: 185000, usage_hours: 1420 },
        { machine_name: 'CNC Machine', machine_cost: 450000, usage_hours: 2100 },
        { machine_name: 'Laser Cutter', machine_cost: 320000, usage_hours: 1680 },
        { machine_name: 'PCB Router', machine_cost: 280000, usage_hours: 1250 },
        { machine_name: 'Oscilloscope', machine_cost: 85000, usage_hours: 2450 },
        { machine_name: 'Signal Gen', machine_cost: 65000, usage_hours: 1100 },
        { machine_name: 'Power Supply', machine_cost: 25000, usage_hours: 980 },
    ],

    // Machines Out of Order
    machinesOutOfOrder: [
        { machine_name: '3D Printer #5', tl_name: 'IIT Mumbai TL', issue: 'Extruder malfunction', downtime: '5 Days', status: 'Out of order' },
        { machine_name: 'CNC Machine #2', tl_name: 'IIT Chennai TL', issue: 'Motor replacement needed', downtime: '3 Days', status: 'Out of order' },
        { machine_name: 'Laser Cutter #1', tl_name: 'NIT Surathkal TL', issue: 'Cooling system fault', downtime: '2 Days', status: 'Out of order' },
        { machine_name: 'Oscilloscope #8', tl_name: 'BITS Pilani TL', issue: 'Display not working', downtime: '1 Day', status: 'Out of order' },
    ],
};

// ==================== MBF MIS DATA SAMPLE DATA ====================

export const mbfMISDataSampleData = {
    // Types of Issues
    typesOfIssues: [
        { issue_type: 'Login Issues', count: 185 },
        { issue_type: 'Booking Problems', count: 152 },
        { issue_type: 'Machine Not Working', count: 128 },
        { issue_type: 'App Performance', count: 95 },
        { issue_type: 'Record Updates', count: 72 },
    ],

    // Issue Resolution Status
    issueResolutionStatus: {
        resolved: 485,
        resolved_percentage: 66.3,
        in_progress: 165,
        in_progress_percentage: 22.6,
        pending: 82,
        pending_percentage: 11.1,
    },

    // Reported Issues by Category
    reportedIssuesByCategory: [
        { category: 'Hardware', count: 185 },
        { category: 'Software', count: 165 },
        { category: 'Network', count: 125 },
        { category: 'Access', count: 98 },
        { category: 'Equipment', count: 82 },
        { category: 'Others', count: 55 },
    ],

    // Recent Issues
    recentIssues: [
        {
            title: 'Unable to login to the MIS system',
            date: new Date().toISOString(),
            priority: 'High',
            status: 'Pending',
        },
        {
            title: 'Machine booking not confirmed',
            date: new Date().toISOString(),
            priority: 'Medium',
            status: 'In Progress',
        },
        {
            title: '3D Printer calibration required',
            date: new Date(Date.now() - 86400000).toISOString(),
            priority: 'High',
            status: 'In Progress',
        },
        {
            title: 'Update student department records',
            date: new Date(Date.now() - 86400000).toISOString(),
            priority: 'Low',
            status: 'Resolved',
        },
        {
            title: 'Dashboard not loading properly',
            date: new Date(Date.now() - 172800000).toISOString(),
            priority: 'High',
            status: 'Resolved',
        },
    ],

    // All TL Stats
    allTLStats: [
        { name_of_tl: 'IIT Mumbai TL', no_of_users: 1250, admin_users: 45, inventory_issues: 125, inventory_purchases: '$15,250', machine_booking_hrs: 2850.5, issues_reported: 85, issues_solved: 68, projects_undergoing: 45 },
        { name_of_tl: 'IIT Chennai TL', no_of_users: 980, admin_users: 38, inventory_issues: 98, inventory_purchases: '$12,800', machine_booking_hrs: 2250.0, issues_reported: 72, issues_solved: 58, projects_undergoing: 38 },
        { name_of_tl: 'NIT Surathkal TL', no_of_users: 750, admin_users: 28, inventory_issues: 75, inventory_purchases: '$9,500', machine_booking_hrs: 1850.5, issues_reported: 55, issues_solved: 45, projects_undergoing: 28 },
        { name_of_tl: 'BITS Pilani TL', no_of_users: 620, admin_users: 22, inventory_issues: 58, inventory_purchases: '$7,200', machine_booking_hrs: 1450.0, issues_reported: 42, issues_solved: 35, projects_undergoing: 22 },
        { name_of_tl: 'VIT Vellore TL', no_of_users: 450, admin_users: 18, inventory_issues: 42, inventory_purchases: '$5,800', machine_booking_hrs: 1150.5, issues_reported: 32, issues_solved: 28, projects_undergoing: 18 },
    ],
};

// ==================== UTILITY FUNCTIONS ====================

/**
 * Check if data is empty or contains only zero values
 * @param {any} data - Data to check
 * @param {string} type - Type of data check ('array', 'object', 'number')
 * @returns {boolean} - True if data is empty or zero
 */
export const isMBFDataEmpty = (data, type = 'auto') => {
    if (data === null || data === undefined) return true;

    // Auto-detect type
    if (type === 'auto') {
        if (Array.isArray(data)) type = 'array';
        else if (typeof data === 'object') type = 'object';
        else if (typeof data === 'number') type = 'number';
        else return true;
    }

    switch (type) {
        case 'array':
            if (!Array.isArray(data) || data.length === 0) return true;
            // Check if all values in array are zero
            return data.every(item => {
                if (typeof item === 'object') {
                    const valueKeys = [
                        'count', 'engagement_count', 'users', 'footfall', 'user_count',
                        'usage_hours', 'quantity', 'total_visits', 'active_users',
                        'total_projects', 'completed_projects', 'weekly', 'monthly', 'yearly',
                        'students_involved', 'projects', 'trainings_completed', 'quizzes_solved'
                    ];
                    return valueKeys.every(key => !item[key] || item[key] === 0);
                }
                return item === 0;
            });

        case 'object':
            if (typeof data !== 'object' || Object.keys(data).length === 0) return true;
            const numericValues = Object.values(data).filter(v => typeof v === 'number');
            return numericValues.length > 0 && numericValues.every(v => v === 0);

        case 'number':
            return data === 0;

        default:
            return true;
    }
};

/**
 * Get MBF sample data based on data type
 * @param {string} dataType - Type of sample data needed  
 * @returns {any} - Sample data for the specified type
 */
export const getMBFSampleData = (dataType) => {
    switch (dataType) {
        // User Statistics
        case 'genderStats':
            return mbfUserStatisticsSampleData.genderStats;
        case 'studentVsAdmin':
            return mbfUserStatisticsSampleData.studentVsAdmin;
        case 'userGrowthTrend':
            return mbfUserStatisticsSampleData.userGrowthTrend;
        case 'tlUserDistribution':
            return mbfUserStatisticsSampleData.tlUserDistribution;
        case 'departmentDistribution':
            return mbfUserStatisticsSampleData.departmentDistribution;
        case 'zoneStatistics':
            return mbfUserStatisticsSampleData.zoneStatistics;

        // Engagement
        case 'cumulativeFootfall':
            return mbfEngagementSampleData.cumulativeFootfall;
        case 'individualTLFootfall':
            return mbfEngagementSampleData.individualTLFootfall;
        case 'peakHoursAnalysis':
            return mbfEngagementSampleData.peakHoursAnalysis;
        case 'activeUsersStatus':
            return mbfEngagementSampleData.activeUsersStatus;
        case 'departmentEngagement':
            return mbfEngagementSampleData.departmentEngagement;
        case 'yearEngagement':
            return mbfEngagementSampleData.yearEngagement;

        // Projects
        case 'cumulativeProjects':
            return mbfProjectsSampleData.cumulativeProjects;
        case 'typesOfProjects':
            return mbfProjectsSampleData.typesOfProjects;
        case 'yearDistribution':
            return mbfProjectsSampleData.yearDistribution;
        case 'departmentProjects':
            return mbfProjectsSampleData.departmentProjects;
        case 'trainingsVsQuizzes':
            return mbfProjectsSampleData.trainingsVsQuizzes;

        // Machine Usage
        case 'mostUsedMachines':
            return mbfMachineUsageSampleData.mostUsedMachines;
        case 'machineStatusOverview':
            return mbfMachineUsageSampleData.machineStatusOverview;
        case 'mostIssuedItems':
            return mbfMachineUsageSampleData.mostIssuedItems;
        case 'costVsUsage':
            return mbfMachineUsageSampleData.costVsUsage;
        case 'machinesOutOfOrder':
            return mbfMachineUsageSampleData.machinesOutOfOrder;

        // MIS Data
        case 'typesOfIssues':
            return mbfMISDataSampleData.typesOfIssues;
        case 'issueResolutionStatus':
            return mbfMISDataSampleData.issueResolutionStatus;
        case 'reportedIssuesByCategory':
            return mbfMISDataSampleData.reportedIssuesByCategory;
        case 'recentIssues':
            return mbfMISDataSampleData.recentIssues;
        case 'allTLStats':
            return mbfMISDataSampleData.allTLStats;

        default:
            return null;
    }
};

const mbfDashboardSampleData = {
    mbfUserStatisticsSampleData,
    mbfEngagementSampleData,
    mbfProjectsSampleData,
    mbfMachineUsageSampleData,
    mbfMISDataSampleData,
    isMBFDataEmpty,
    getMBFSampleData,
};